import { Api } from '@deepcloud/api-base'
import { mergeConfig } from '@deepcloud/http-client'
import { withQueryParams } from '../../../shared'
import type {
  HttpClient,
  HttpClientRequestConfig,
} from '@deepcloud/http-client'
import type {
  FavoriteRequest,
  InitialPermission,
  UserResponse,
  UsersGetReviewersParams,
  UsersRemoveFavoriteParams,
} from '../../@types'

export class UsersAPI extends Api {
  constructor(httpClient: HttpClient) {
    super(httpClient)
  }

  /**
   * Get Initial Permission
   * -------------------
   * Errors:
   * - none documented
   */
  async getInitialPermission(config?: HttpClientRequestConfig) {
    const path = `/users/initial`

    return this.httpClient.get<InitialPermission>(path, config)
  }

  /**
   * Get Employee Groups
   * -------------------
   * Errors:
   * - none documented
   */
  async getEmployeeGroups(config?: HttpClientRequestConfig) {
    const path = `/users/employeegroups`

    return this.httpClient.get<string[]>(path, config)
  }

  /**
   * Get Editors
   * -------------------
   * Errors:
   * - none documented
   */
  async getEditors(config?: HttpClientRequestConfig) {
    const path = `/users/editors`

    return this.httpClient.get<UserResponse[]>(path, config)
  }

  /**
   * Get Assignees
   * -------------------
   * Errors:
   * - none documented
   */
  async getAssignees(config?: HttpClientRequestConfig) {
    const path = `/users/assignees`

    return this.httpClient.get<UserResponse[]>(path, config)
  }

  /**
   * Get Reviewers
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async getReviewers(
    params?: UsersGetReviewersParams,
    config?: HttpClientRequestConfig,
  ) {
    const path = `/users/reviewers`

    return this.httpClient.get<UserResponse[]>(
      path,
      mergeConfig({ params }, config),
    )
  }

  /**
   * Add Favorite
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async addFavorite(
    payload: FavoriteRequest,
    config?: HttpClientRequestConfig,
  ) {
    const path = `/users/favorites`

    return this.httpClient.post<Record<string, string>>(path, payload, config)
  }

  /**
   * Remove Favorite
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async removeFavorite(
    params: UsersRemoveFavoriteParams,
    config?: HttpClientRequestConfig,
  ) {
    const path = withQueryParams(`/users/favorites`, params)

    return this.httpClient.delete<Record<string, string>>(path, config)
  }
}
